import { StyleSheet, View } from "@react-pdf/renderer"
import React from "react"

const styles = StyleSheet.create({
  box: {
    backgroundColor: '#fafafa',
    marginTop: 8,
    padding: 8,
  },
})

const ContentBox = ({ children }) => (
  <View style={styles.box}>
    {children}
  </View>
)

export default ContentBox
